<template>
  <div class="tw-max-h-full">
    <GraphqlDataTable
      :query
      :order-by="initialOrder"
      :filter-black-list="['accounts', 'externalIdentifiers']"
      :max-height-adjustment="30"
      :bulk-actions="actions"
    >
      <template #action="{ row }">
        <HireActionColumn :row="row" />
      </template>
      <template #full-screen-globals>
        <ModalRemindToBill
          :hire-ids="selectedRowsIds"
          :is-open="openRemindModal"
          bulk-reminder
          :default-message="defaultRemindToBillText as string"
          @closed="selectedRowsIds = []"
          @reminder-sendt="selectedRowsIds = []"
        />
      </template>
    </GraphqlDataTable>
  </div>
</template>

<script lang="ts" setup>
import { TypedQueryDocumentNode } from 'graphql/index'
import { WdsIconNameEnum } from '@worksome/wds-components'
import { computed, ref } from 'vue'
import GraphqlDataTable from '@/components/GraphqlDataTable/GraphqlDataTable.vue'
import { graphql } from '@/gql'
import { HireOrderByColumn, SortOrder } from '@/gql/graphql'
import HireActionColumn from '@/components/GraphqlDataTable/columns/Hire/HireActionColumn.vue'
import { DataTableBulkAction } from '@/components/GraphqlDataTable/types'
import { $t } from '@/composables/translation'
import ModalRemindToBill from '@/components/ModalRemindToBill.vue'
import { useAccountSettings } from '@/composables/useAccountSettings'

const query = graphql(`
  query HireContractsQuery(
    $accounts: [ID!]
    $search: String
    $page: Int!
    $first: Int!
    $orderBy: [HiresOrderByClauseInput!]
    $activeStatus: [HireActiveStatus!]
    $contractType: [ContractType!]
    $startDateRange: DateRangeInput
    $createdAtDateRange: DateRangeInput
    $hireOwners: [ID!]
    $workers: [ID!]
    $externalIdentifiers: [String!]
    $recruiterOwnershipIsExpired: Boolean
  ) {
    hires(
      accounts: $accounts
      search: $search
      page: $page
      first: $first
      orderBy: $orderBy
      recruiterOwnershipIsExpired: $recruiterOwnershipIsExpired
      startDateRange: $startDateRange
      createdAtDateRange: $createdAtDateRange
      contractType: $contractType
      activeStatus: $activeStatus
      workers: $workers
      externalIdentifiers: $externalIdentifiers
      owners: $hireOwners
      includeDeleted: true
    ) {
      paginatorInfo {
        ...PaginatorInfoFragment
      }
      data {
        ...HireCreatedColumn
        ...HireAvatarColumn

        ...HireTitleNavigationPoNumberColumn

        startDate
        endDate

        ...RateColumnHire

        ...HireHasStaffingAgencyColumn
        # Payment requests
        ...HirePaymentRequestColumn

        ...HireClassificationColumn

        ...HireContractPopoverColumn

        ...HireActionColumn
      }
    }
  }
`) as TypedQueryDocumentNode

const initialOrder = {
  field: HireOrderByColumn.StartDate,
  order: SortOrder.Desc,
}

const selectedRowsIds = ref<string[]>([])

const openRemindModal = computed(() => selectedRowsIds.value.length > 0)
const defaultRemindToBillText = useAccountSettings('default_message_remind_freelancer_to_bill')

const actions: DataTableBulkAction[] = [
  {
    name: $t('Remind to submit payment request'),
    icon: WdsIconNameEnum.SEND_ALT,
    action: (rows) => {
      selectedRowsIds.value = Object.values(rows).map((row) => (row as any)?.number)
    },
  },
]
</script>
